import { Navigate, Route, Routes } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Main from './components/Main/Main';
import { loadZonesRequest } from './redux/zoneRedux';
import { useEffect } from 'react';
import MainLayout from './components/layout/MainLayout/MainLayout';

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    const start = async () => {
      await dispatch(loadZonesRequest());
    };
    start();
  }, [dispatch]);

  return (
    <MainLayout>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </MainLayout>
  );
}

export default App;
